__turbopack_context__.v({
  "closeButton": "styles-module-scss-module__cai10a__closeButton",
  "closeButtonVisible": "styles-module-scss-module__cai10a__closeButtonVisible",
  "downloadItem": "styles-module-scss-module__cai10a__downloadItem",
  "downloadItemIcon": "styles-module-scss-module__cai10a__downloadItemIcon",
  "downloadItemName": "styles-module-scss-module__cai10a__downloadItemName",
  "overlay": "styles-module-scss-module__cai10a__overlay",
  "overlayVisible": "styles-module-scss-module__cai10a__overlayVisible",
  "relatedData": "styles-module-scss-module__cai10a__relatedData",
  "relatedDataContent": "styles-module-scss-module__cai10a__relatedDataContent",
  "relatedDataContentFixed": "styles-module-scss-module__cai10a__relatedDataContentFixed",
  "relatedDataContentFixedVisible": "styles-module-scss-module__cai10a__relatedDataContentFixedVisible",
  "relatedDataIcons": "styles-module-scss-module__cai10a__relatedDataIcons",
  "relatedDataMenu": "styles-module-scss-module__cai10a__relatedDataMenu",
  "relatedDataMenuVisible": "styles-module-scss-module__cai10a__relatedDataMenuVisible",
  "relatedDataSection": "styles-module-scss-module__cai10a__relatedDataSection",
  "relatedDataSectionLabel": "styles-module-scss-module__cai10a__relatedDataSectionLabel",
  "relatedDataSectionLink": "styles-module-scss-module__cai10a__relatedDataSectionLink",
  "relatedDataSectionList": "styles-module-scss-module__cai10a__relatedDataSectionList",
});
